import Link from "next/link";
import React, { PropsWithChildren } from "react";

export enum ArrowDirection {
	none = 0,
	right = 1,
	left = 2,
}

export interface ILinkProps {
	/** the url to link to */
	readonly href: string;
	/** the tooltip of the link */
	readonly title?: string;
	/** the direction of the arror, or none if no arrow */
	readonly arrow?: ArrowDirection;
	/** true if the link is to an external site, false otherwise. Uses <a> instead of <Link> for external tags */
	readonly external?: boolean;
	/** true if your wrapping div should be excluded from Google snippets. Used to prevent the content from showing on search results. */
	readonly noSnippet?: boolean;
}

/**
 * A formatted link. Displays as a block element. Capable of showing an arrow to the right or left.
 * @param linkProps - link properties
 */
export const FormattedLink: React.FC<PropsWithChildren<ILinkProps>> = ({
	href,
	title,
	children,
	arrow = ArrowDirection.right,
	external,
	noSnippet,
}) => {
	return (
		<div {...(noSnippet ? { "data-nosnippet": "data-nosnippet" } : {})}>
			{external ? (
				<a
					href={href}
					title={title}
					id={`formatted_link_${href}`}
					className={`font-slightlyfun text-epic-light-red hover:underline focus-within:underline md:text-lg text-base transition-[text-decoration-color] decoration-transparent hover:decoration-current focus-within:decoration-current duration-300 ease-in-out`}
				>
					{arrow === ArrowDirection.left ? "\u2190\u00A0" : ""}
					{children}
					{arrow === ArrowDirection.right ? "\u00A0\u2192" : ""}
				</a>
			) : (
				<Link
					href={href}
					title={title}
					id={`formatted_link_${href}`}
					className={`font-slightlyfun text-epic-light-red hover:underline focus-within:underline md:text-lg text-base transition-[text-decoration-color] decoration-transparent hover:decoration-current focus-within:decoration-current duration-300 ease-in-out`}
				>
					{arrow === ArrowDirection.left ? "\u2190\u00A0" : ""}
					{children}
					{arrow === ArrowDirection.right ? "\u00A0\u2192" : ""}
				</Link>
			)}
		</div>
	);
};
